export const prefixPath = '/configurator/'

const routes = [
  { // 车型列表页
    path: prefixPath + 'carlist',
    name: 'carlist',
    component: () => import('@/views/carlist')
  },
  { // 明细页
    path: prefixPath + 'overview',
    name: 'overview',
    component: () => import('@/views/overview')
  },
  { // 配置页
    path: prefixPath + ':vehicle?',
    name: 'config',
    component: () => import('@/views/config'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '*',
    redirect: {
      name: 'config'
    }
  }
 ]

 export default routes
